<template>
    <div class="card" :style="`background-image: url(${bgMap})`">
        <div class="header">
            <span>{{ title }}</span>
            <slot name="more"></slot>
        </div>
        <div class="main">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        bgMap: {
            type: String,
            default: require('../assets/images/card_box.png')
        }
    }
}
</script>

<style scoped lang="scss">
.card {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .header {
        height: 44px;
        line-height: 46px;
        color: #40b9f6;
        font-size: 18px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        span {
            &:last-child {
                cursor: pointer;
                font-size: 16px;
            }
        }
    }
    .main {
        width: 100%;
        height: calc(100% - 44px);
        .table-info {
            padding: 0 3px !important;
            ::v-deep {
                .header {
                    height: 36px;
                }
                .list {
                    margin-top: 9px;
                    height: calc(100% - 45px);
                }
            }
        }
    }
}
</style>
